module.exports = __webpack_public_path__ + "img/personal.26d8432e.svg";